module.exports = __webpack_public_path__ + "static/media/otter.14b8f8f3.svg";